<template>
  <span class="date-cell" v-if="parsed" :title="parsed.toUTCString()">
    <span class="date-cell__day">{{ day }}</span>
    <span class="date-cell__time">{{ time }} GMT</span>
  </span>
  <span v-else>—</span>
</template>

<script>
import "./dateCell.scss";

const pad = (value) => String(value).padStart(2, "0");

// Дата в таблицах: день сверху, время (UTC, с секундами) снизу
export default {
  name: "DateCell",
  props: {
    value: { type: [String, Number, Date], default: null }
  },
  computed: {
    parsed() {
      if (!this.value) return null;
      const date = new Date(this.value);
      return Number.isNaN(date.getTime()) ? null : date;
    },
    day() {
      const date = this.parsed;
      return `${pad(date.getUTCDate())}.${pad(date.getUTCMonth() + 1)}.${date.getUTCFullYear()}`;
    },
    time() {
      const date = this.parsed;
      return `${pad(date.getUTCHours())}:${pad(date.getUTCMinutes())}:${pad(date.getUTCSeconds())}`;
    }
  }
};
</script>
